









import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component
export default class Tabs extends Vue {
    @Prop(String) public value!: string;
    @Prop() public submit!: boolean;

    public state = 'pay';
    @Watch('submit')
    public init() {
        if (this.submit) {
          this.state = 'pay';
        }

    }
    public beforeMount() {
        if (this.$route.query.id) {
          this.state = this.value;
        }
        this.$emit('update:value', this.state);
    }
    public select(state: string) {
        this.state = state;
        this.$emit('update:value', this.state);

    }
}
